// extracted by css-extract-rspack-plugin
export default {"root":"root--mq_NGtuS9mIF0Rl1"};